'use strict';

/**
 * buildIntegrationSavePayload(integration) — the PATCH body for
 * Integration.prototype$patchAttributes() built from edit-integration.js
 * save() (area #13). The edit-integration.html form only exposes a single
 * editable field (`name` — provider, profile.displayName, profile.username
 * and providerId are all rendered `disabled`), so the payload is
 * intentionally narrow: it must carry exactly `{ name }`, never the id
 * (that belongs in the where-clause, not the patch body) and never any of
 * the read-only provider/profile fields even if present on the bound model.
 *
 * @param {{id: *, name: *}} integration - $ctrl.integration
 * @returns {{name: *}}
 */
function buildIntegrationSavePayload(integration) {
    return { name: integration.name };
}

/**
 * saveIntegration(context) — the full save() flow extracted for testing
 * without Angular DI: patch the name, then refetch the integration with the
 * standard Includes.integrations filter, write it into the Store, and mark
 * the form pristine again. Mirrors edit-integration.js save() exactly.
 *
 * context: { Integration, Store, Includes, integration, form }
 */
function saveIntegration(context) {
    return context.Integration
        .prototype$patchAttributes(
            { id: context.integration.id },
            buildIntegrationSavePayload(context.integration),
        )
        .$promise
        .then((response) => {
            return context.Integration.findById({
                id: response.id,
                filter: context.Includes.integrations,
            }).$promise;
        })
        .then((integration) => {
            context.Store.setSingleModelData('integrations', context.integration.id, integration);
            if (context.form && context.form.$setPristine) {
                context.form.$setPristine();
            }
            return integration;
        })
        .catch((error) => {
            return error;
        });
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        buildIntegrationSavePayload,
        saveIntegration,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('editIntegrationSave', {
        buildIntegrationSavePayload,
        saveIntegration,
    });
}
